import { TechManualsPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    TechManualsPage,
    '/tech-manuals',
    [new RequiresAuthGuard(true), new RequiresUsertypesGuard(['system-admin'])],
    {
      name: 'Technical Documentation',
    }
  ),
]
